import { useEffect } from 'react';
import { useAppSelector } from '@doda/common/src/redux/hooks';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import {
  measureMatchedTagCassetteAbTest,
  measureMatchedTagCassetteImpression,
} from '@doda/common/src/logics/jobSearchDetail/analytics';
import { MatchedTagCassetteABTestPattern } from '@doda/common/src/constants/matchedTagCassette/matchedTagCassette';

/**
 * Matched Tag Cassette AB test and impression event measurement
 * @param abTestGroup AB test group number
 * @param matchedTags Array of matched skill tags
 */
export const useMatchedTagCassetteAnalytics = (
  abTestGroup: number | null | undefined,
  matchedTags: string[]
) => {
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  useEffect(() => {
    if (!isAdobeScript) return;
    setTimeout(() => {
      measureMatchedTagCassetteAbTest(abTestGroup);
      if (
        abTestGroup === MatchedTagCassetteABTestPattern.TEST1 ||
        abTestGroup === MatchedTagCassetteABTestPattern.TEST2
      ) {
        measureMatchedTagCassetteImpression(matchedTags);
      }
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript]);
};
